// extracted by mini-css-extract-plugin
export default {"cta":"jH-z","disabled":"kH-z"};